import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { PackageOptionView } from 'selectors/cart/cartSelectors'
import { OfferPackageOptionView } from 'selectors/offerPageSelectors'
import LePackageUpgradeCardTwoColumnsVariantDesktop from './LePackageUpgradeCardTwoColumnsVariantDesktop'
import LePackageUpgradeCardTwoColumnsVariantMobile from './LePackageUpgradeCardTwoColumnsVariantMobile'

const DesktopContainer = styled.div`
  height: 100%;
  display: none;

  ${mediaQueryUp.md} {
    display: block;
  }
`

const MobileContainer = styled.div`
  height: 100%;

  ${mediaQueryUp.md} {
    display: none;
  }
`
interface Props {
  packageUpgrade: PackageOptionView;
  selectedPackage: OfferPackageOptionView;
  hasFlightsSelected?: boolean;
  onUpgrade: () => void;
  onNoThanks: () => void;
}

function LePackageUpgradeCardTwoColumnsVariant(props: Props) {
  return (
    <>
      <DesktopContainer>
        <LePackageUpgradeCardTwoColumnsVariantDesktop {...props}/>
      </DesktopContainer>
      <MobileContainer>
        <LePackageUpgradeCardTwoColumnsVariantMobile {...props} />
      </MobileContainer>
    </>
  )
}

export default LePackageUpgradeCardTwoColumnsVariant
